import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import RichTextEditor from 'Components/UI/RichTextEditor';
import Typography from '@material-ui/core/Typography';

const styles = theme => ({
  editor: {
    width: '100%',
  },
  label: {
    color: theme.palette.facet.primaryGray,
  },
  description: {
    marginBottom: theme.spacing(1),
  },
});

const GoalFormDescriptionField = ({ classes, label, ...rest }) => {
  return (
    <div className={classes.description}>
      <Typography className={classes.label} variant="body1">{label}</Typography>
      <RichTextEditor className={classes.editor} {...rest} />
    </div>
  );
};

export default withStyles(styles)(GoalFormDescriptionField);
